var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',{staticClass:"v-datatable__expand-row"},[_c('td',{class:['v-datatable__expand-col ' + (_vm.expanded ? 'v-datatable__expand-col--expanded' : '')],attrs:{"colspan":_vm.colspan}},[_c('v-expand-transition',[_vm._t("default")],2)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }